'use strict';
import React from 'react';

/**
 * Selected Items component.
 * Allows the user to quickly dismiss one or more selections from a multi-select drop down list.
 * An enclosing class (SelectedItems) is provided, but currently unstyled. It is not currently required.
 *
 * Usage:
 *
 * ```Javascript
 * <InputField name="name" iconButton selectedItem={2}></InputField>
 * <SelectedItemList>
 * 	 <SelectedItem>Added Item</SelectedItem>
 * 	 <SelectedItem>Added Item2</SelectedItem>
 * </SelectedItemList>
 * ```
 *
 * @extends {React.Component}
 */
class SelectedItemList extends React.Component {
  /**
   * @return {JSX} JSX component markup.
   */
  render () {
    return (
      <div className="SelectedItems">
        <ul className="SelectedItems-list">
          {this.props.children}
        </ul>
      </div>
    );
  }
}

SelectedItemList.defaultProps = {
};

SelectedItemList.propTypes = {
};

export default SelectedItemList;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/inputs/selectedItems/selectedItemList.jsx